import axios from 'axios';
import AppConfig from "../../AppConfig";

let URL = AppConfig.HOST_API();

export default {

    // KATEGORIE

    postPlik(dane, dostep, nazwa, rozmiar, slug, typ) {
        return axios({
            method: 'POST',
            headers: {'Content-Type': 'application/json'},
            url: URL + 'api/plik' + AppConfig.V_LOG(),
            auth: {
                username: JSON.parse(sessionStorage.getItem('adminLoggedIn')).login,
                password: JSON.parse(sessionStorage.getItem('adminLoggedIn')).pass
            },
            data: {
                "dane": dane,
                "dokumentTyp": "STRONA_WPIS",
                "dostep": dostep,
                "nazwa": nazwa,
                "rozmiar": rozmiar,
                "slug": slug,
                "typ": typ
            }
        });
    },

    putPlik(dane, dostep, nazwa, rozmiar, slug, typ, opis) {
        return axios({
            method: 'PUT',
            headers: {'Content-Type': 'application/json'},
            url: URL + 'client/api/auth/plik' + AppConfig.V_LOG(),
            auth: {
                username: JSON.parse(sessionStorage.getItem('adminLoggedIn')).login,
                password: JSON.parse(sessionStorage.getItem('adminLoggedIn')).pass
            },
            data: {
                "dane": dane,
                "dokumentId": -1,
                "opis": opis,
                "dokumentTyp": "STRONA_WPIS",
                "dostep": dostep,
                "nazwa": nazwa,
                "rozmiar": rozmiar,
                "slug": slug,
                "typ": typ
            }
        });
    },

    getPlik(slug) {
        return axios({
            method: 'GET',
            headers: {'Content-Type': 'application/json'},
            url: URL + 'client/api/plik/info/' + slug + AppConfig.V_LOG(),
        });
    },
}



// WEBPACK FOOTER //
// ./src/components/admin/adminComponents/AdminPlikiService.js